import { useTranslation } from 'react-i18next';

type RecursoKind = 'manter' | 'reformar' | 'reformar_parcial';

interface Props {
  kind: RecursoKind;
  caseId: string;
  /** Se a decisão final ainda não foi emitida, usa "hoje" para o preview. */
  decisaoEpochMs?: number;
  /** Razão geral SEM PII — campo livre opcional do membro decisor. */
  razao?: string;
}

/**
 * Read-only render do template da carta de notificação ao denunciante.
 * Phase 5 plan template: "A decisão sobre a denúncia ID-XXXX foi
 * [mantida/reformada/parcialmente reformada] pelo Painel de Recurso em [data].
 * [Razão geral sem PII]."
 *
 * Renderizado em <DecisaoRecursoPage> antes do submit para o membro conferir
 * o que vai ser cifrado e entregue ao denunciante via mockMessages
 * (origin=recurso_decidido — Plan 05-02 task 1).
 */
export function CartaRecursoPreview({ kind, caseId, decisaoEpochMs, razao }: Props): JSX.Element {
  const { t } = useTranslation();
  const date = new Date(decisaoEpochMs ?? Date.now()).toLocaleDateString('pt-BR');
  const shortId = caseId.slice(0, 12).toUpperCase();
  const razaoFinal = razao && razao.trim().length > 0 ? razao : t('carta_template.razao_default');

  const text = t(`carta_template.${kind}`, {
    shortId,
    date,
    razao: razaoFinal,
  });

  return (
    <div className="carta-preview" role="region" aria-label={t('decisao.preview_title')}>
      {text}
    </div>
  );
}
